module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 8
// module chunks = 0